import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 7L5.5 4L2.5 1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRightSmall;
